const milestones = [
  {
    company: "Mindhop",
    location: "White Plains, NY",
    duration: "Jan 2025 - Present",
    roles: [
      {
        title: "Software Engineer",
        description: [
          "As a Software Engineer at Mindhop since January 2025, I’ve refactored over 3,000 lines of legacy React code with TanStack Query—cutting API call redundancy by 40%—and optimized PostgREST queries to slash dashboard load times by 30%. I built 10+ reusable Next.js and Tailwind components to accelerate feature delivery, integrated KendoReact and eCharts for richer, interactive data visualizations, and wrote PostGIS SQL to improve map-search accuracy within defined boundaries. To round out our workflow, I automated builds and deployments by crafting Dockerfiles and GitHub Actions pipelines, removing manual steps and speeding up releases.",
        ],
      },
    ],
  },
  {
    company: "Bonny Systems",
    location: "Wayne, NJ",
    duration: "Jan 2023 - Dec 2024",
    roles: [
      {
        title: "Junior Software Engineer",
        description: [
          "I partnered with local businesses to enhance their web functionalities and server-side operations. My work often involved developing REST APIs, where I've successfully used technologies like Node.js, TypeScript, and PostgreSQL to boost our system’s efficiency by 20%. I enjoy collaborating closely with frontend engineers, breaking down complex projects into clear, actionable steps to streamline our backend development efforts. I also took the lead on improving our CI/CD processes, which effectively reduced our deployment times from 15 minutes to just 5 minutes with AWS, significantly speeding up our project delivery.",
        ],
      },
    ],
  },
  {
    company: "Code Ninjas",
    location: "Saddlebrook, NJ",
    duration: "Oct 2024 - Dec 2024",
    roles: [
      {
        title: "Computer Science Teacher",
        description: [
          "As a Computer Science teacher at Code Ninjas, I am responsible for teaching and assisting students ages 5-16 foundational programmiming concepts. More specifically, I assisnt in teaching important concepts in JavaScript to intermediate students, and advanced topics like OOP and event handling in C# and Unity for advanced students.",
        ],
      },
    ],
  },
  {
    company: "Cova Laboratories",
    location: "Ramsey, NJ",
    duration: "Jan 2023 - Jan 2024",
    roles: [
      {
        title: "Laboratory Technician",
        description: [
          "While wokring as a Lab-Tech, I performed molecular COVID and Influenza testing with accuracy and efficiency. I was responsible for implementing quality control measures to ensure the reliability of test results. Committed to maintaining the highest standards of laboratory practice, I ensured strict adherence to government protocols and safety measures, fostering a secure and compliant laboratory environment while upholding the utmost standards of data privacy and ethics.",
        ],
      },
    ],
  },
];

export default milestones;
